import { render, staticRenderFns } from "./import-error-table.vue?vue&type=template&id=f48e9548&scoped=true&"
import script from "./import-error-table.vue?vue&type=script&lang=ts&"
export * from "./import-error-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e9548",
  null
  
)

export default component.exports